/**
 * Content page TOC: sticky offset + current-section state.
 * Vanilla JS only. Safe to include on any page using .ovs-content.
 * cache-bust 2026-09-17-r16
 */
(function () {
  var root = document.querySelector(".ovs-content");
  if (!root) return;

  var header =
    document.querySelector("sticky-header") ||
    document.querySelector(".header-wrapper");
  var disclosure = root.querySelector(".ovs-content__toc-disclosure");
  var links = Array.prototype.slice.call(
    root.querySelectorAll('.ovs-content__toc-link[href^="#"]'),
  );
  if (!links.length) return;

  var targets = links
    .map(function (link) {
      var id = link.getAttribute("href").slice(1);
      return id ? document.getElementById(id) : null;
    })
    .filter(Boolean);

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function isNarrowViewport() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function tocBarHeight() {
    if (!disclosure || !isNarrowViewport()) return 0;
    var summary = disclosure.querySelector(".ovs-content__toc-summary");
    return summary ? Math.round(summary.getBoundingClientRect().height) : 0;
  }

  function stickyHeaderHeight() {
    return header ? Math.round(header.getBoundingClientRect().height) : 0;
  }

  function headerOffset() {
    return stickyHeaderHeight() + tocBarHeight();
  }

  function syncStickyHeaderVar() {
    document.documentElement.style.setProperty(
      "--ovs-sticky-header-height",
      stickyHeaderHeight() + "px",
    );
  }

  function syncTocHeightVar() {
    document.documentElement.style.setProperty(
      "--ovs-mobile-toc-height",
      tocBarHeight() + "px",
    );
  }

  function closeMobileToc() {
    if (disclosure && isNarrowViewport()) {
      disclosure.removeAttribute("open");
    }
  }

  function syncTocDisclosure() {
    if (!disclosure) return;
    if (!isNarrowViewport()) {
      disclosure.setAttribute("open", "");
    }
    syncTocHeightVar();
  }

  function setActive(id) {
    links.forEach(function (link) {
      var match = link.getAttribute("href") === "#" + id;
      if (match) {
        link.setAttribute("aria-current", "location");
      } else {
        link.removeAttribute("aria-current");
      }
    });
  }

  function updateFromScroll() {
    var offset = headerOffset() + 24;
    var current = targets[0] ? targets[0].id : "";
    targets.forEach(function (section) {
      if (section.getBoundingClientRect().top - offset <= 0) {
        current = section.id;
      }
    });
    if (current) setActive(current);
  }

  function scrollToAnchor(id) {
    var target = document.getElementById(id);
    if (!target) return;
    var y =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      headerOffset() -
      16;
    window.scrollTo({
      top: Math.max(0, y),
      behavior: prefersReducedMotion() ? "auto" : "smooth",
    });
  }

  function positionAnchor(id) {
    if (!id) return;
    closeMobileToc();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        syncTocHeightVar();
        scrollToAnchor(id);
        setActive(id);
      });
    });
  }

  function goToAnchor(id) {
    if (!id) return;
    if (history.pushState && window.location.hash !== "#" + id) {
      history.pushState(null, "", "#" + id);
    }
    positionAnchor(id);
  }

  links.forEach(function (link) {
    link.addEventListener("click", function (event) {
      var id = link.getAttribute("href").slice(1);
      if (!id) return;
      event.preventDefault();
      goToAnchor(id);
    });
  });

  Array.prototype.slice
    .call(
      root.querySelectorAll(
        '.ovs-content__category-action[href^="#"], .ovs-content__nav-link[href^="#"], .ovs-content__path-actions a[href^="#"]',
      ),
    )
    .forEach(function (link) {
      link.addEventListener("click", function (event) {
        var id = link.getAttribute("href").slice(1);
        if (!id) return;
        event.preventDefault();
        goToAnchor(id);
      });
    });

  if (disclosure) {
    disclosure.addEventListener("toggle", syncTocHeightVar);
  }

  window.addEventListener(
    "scroll",
    function () {
      syncStickyHeaderVar();
      updateFromScroll();
    },
    { passive: true },
  );
  window.addEventListener("resize", function () {
    syncStickyHeaderVar();
    syncTocHeightVar();
    updateFromScroll();
  });
  window.addEventListener("popstate", function () {
    if (window.location.hash) {
      positionAnchor(window.location.hash.slice(1));
    }
  });
  if (window.matchMedia) {
    window
      .matchMedia("(max-width: 749px)")
      .addEventListener("change", function (event) {
        if (event.matches) {
          closeMobileToc();
          syncTocHeightVar();
          return;
        }
        syncTocDisclosure();
      });
  }
  syncStickyHeaderVar();
  syncTocDisclosure();
  updateFromScroll();

  if (window.location.hash) {
    positionAnchor(window.location.hash.slice(1));
    if (document.readyState !== "complete") {
      window.addEventListener(
        "load",
        function () {
          if (window.location.hash) {
            positionAnchor(window.location.hash.slice(1));
          }
        },
        { once: true },
      );
    }
  }
})();

(function () {
  var root = document.querySelector(".ovs-content");
  if (!root) return;

  Array.prototype.slice
    .call(root.querySelectorAll('a[href^="http"]'))
    .forEach(function (link) {
      var url;
      try {
        url = new URL(link.href);
      } catch (error) {
        return;
      }
      if (url.origin === window.location.origin) return;
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
      if (!link.querySelector(".visually-hidden")) {
        var hint = document.createElement("span");
        hint.className = "visually-hidden";
        hint.textContent = " Opens in a new window.";
        link.appendChild(hint);
      }
    });
})();

/**
 * Content-page breadcrumbs: keep one line by hiding intermediate ancestors
 * from measured width. Home and the current page stay visible.
 * Scoped to [data-ovs-crumb-collapse].
 */
(function () {
  var navs = document.querySelectorAll(
    ".ovs-content__crumbs[data-ovs-crumb-collapse]",
  );
  if (!navs.length) return;

  function bind(nav) {
    var list = nav.querySelector(".ovs-ts-breadcrumb__list");
    if (!list) return;

    var ellipsis = list.querySelector(".ovs-content__crumb-ellipsis");
    var items = Array.prototype.slice
      .call(list.children)
      .filter(function (item) {
        return !item.classList.contains("ovs-content__crumb-ellipsis");
      });
    if (items.length < 2) return;

    var home = items[0];
    var homeIndex;
    for (homeIndex = 0; homeIndex < items.length; homeIndex += 1) {
      if (items[homeIndex].classList.contains("ovs-content__crumb-home")) {
        home = items[homeIndex];
        break;
      }
    }
    var current = items[items.length - 1];
    var parent = items.length > 2 ? items[items.length - 2] : null;
    var intermediates = items.filter(function (item) {
      return item !== home && item !== parent && item !== current;
    });

    if (parent && parent !== home) {
      parent.classList.add("ovs-content__crumb-parent");
    }

    function overflows() {
      return list.scrollWidth - list.clientWidth > 1;
    }

    function apply() {
      var i;

      intermediates.forEach(function (item) {
        item.removeAttribute("hidden");
      });
      if (home) {
        home.removeAttribute("hidden");
      }
      if (ellipsis) {
        ellipsis.setAttribute("hidden", "");
      }
      if (parent) {
        parent.classList.remove("ovs-content__crumb-shrink");
        parent.removeAttribute("hidden");
      }

      for (i = 0; i < intermediates.length; i += 1) {
        if (!overflows()) {
          break;
        }
        intermediates[i].setAttribute("hidden", "");
        if (ellipsis) {
          ellipsis.removeAttribute("hidden");
        }
      }

      if (overflows() && parent && parent !== home) {
        parent.classList.add("ovs-content__crumb-shrink");
      }
    }

    var frame = 0;
    function schedule() {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        apply();
      });
    }

    apply();
    if (window.ResizeObserver) {
      new ResizeObserver(schedule).observe(nav);
    }
    window.addEventListener("resize", schedule);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule);
    }
  }

  Array.prototype.forEach.call(navs, bind);
})();
